import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const host = import.meta.env.VITE_BE_HOST;

export const authorizedApi = createApi({
  reducerPath: 'authorizedApi',
  baseQuery: async (args, api, extraOptions) => {
    const state = api.getState();

    const token = state.auth.privyToken;

    if (!token) {
      return { error: { status: 401, data: 'No auth token found' } };
    }

    const baseQuery = fetchBaseQuery({
      baseUrl: `${host}/api`,
      credentials: 'include',
      prepareHeaders: (headers) => {
        if (token) {
          headers.set('Authorization', `Bearer ${token}`);
        }
        return headers;
      },
    });

    return baseQuery(args, api, extraOptions);
  },
  tagTypes: ['TokenBalance'],
  endpoints: () => ({}),
});
